import React from "react";
import CSSModules from "react-css-modules";
import PropTypes from "prop-types";
import styles from "./info-box.scss";

class InfoBox extends React.Component {
  static propTypes = {
    title: PropTypes.node,
    body: PropTypes.node,
    type: PropTypes.oneOf(["error", "warning"]),
    dataAt: PropTypes.string,
  };

  render() {
    const { title, body, dataAt, type = "warning" } = this.props;
    return (
      <div styleName={`info-box ${type}`} data-at={dataAt}>
        {title && <div styleName="info-box-title">{title}</div>}
        {body && <div styleName="info-box-body">{body}</div>}
      </div>
    );
  }
}

export default CSSModules(styles, { allowMultiple: true })(InfoBox);



// WEBPACK FOOTER //
// ./src/components/common/info-box/info-box.js